import React, { useState } from 'react';
import './App.css';

const HazardObservationForm = () => {
  const [formData, setFormData] = useState({
    documentNo: 'FORM-QHSE-MMS-014-E',
    revision: '01',
    date: '',
    department: '',
    place: '',
    time: '',
    description: '',
    immediateAction: '',
    suggestion: '',
    observedBy: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.department || !formData.place || !formData.date || !formData.description) {
      alert('Please fill in all required fields');
      return;
    }

    try {
      const response = await fetch('YOUR_API_ENDPOINT', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });
  
      const result = await response.json();
  
      if (result.success) {
        setFormData({
          documentNo: 'FORM-QHSE-MMS-014-E',
          revision: '01',
          date: '',
          department: '',
          place: '',
          time: '',
          description: '',
          immediateAction: '',
          suggestion: '',
          observedBy: ''
        });
  
        alert('Hazard observation submitted successfully!');
      } else {
        throw new Error('Failed to submit form');
      }
    } catch (error) {
      console.error('Submission error:', error);
      alert('Failed to submit form. Please try again.');
    }
  };

  return (
    <div className="font-montserrat min-h-screen flex flex-col">
      {/* Header - Full width always */}
      <header className="bg-[#003366] w-full py-4">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between">
            <img 
              src="./logo.png" 
              alt="Mazenco Marine Services Logo" 
              className="h-16 md:h-19"
            />
            <div className="text-right">
              <h1 className="text-white text-xl md:text-3xl font-bold">Mazenco Marine Services</h1>
              <h2 className="text-[#00b4d8] text-lg md:text-2xl mt-1">HAZARD OBSERVATION CARD</h2>
            </div>
          </div>
        </div>
      </header>

      <main className="flex-1">
        <div className="max-w-2xl mx-auto px-4 py-6 w-full">
          <div className="bg-white shadow-md rounded-lg mt-4 md:mt-6 p-4 md:p-6">
            <div className="bg-blue-50 border-l-4 border-[#003366] p-4 mb-6">
              <div className="text-sm text-gray-700 space-y-1">
                <p>Document No.: {formData.documentNo}</p>
                <p>Revision: {formData.revision}</p>
                <p>Reference Document: WI.MMS-01-24</p>
              </div>
            </div>

            <h2 className="text-xl md:text-2xl font-bold mb-6 text-center text-[#003366]">
              SAFETY OBSERVATION/EVALUATION CARD
            </h2>
            
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium mb-1">Dept./Company *</label>
                  <input
                    type="text"
                    required
                    className="w-full p-2 border rounded focus:border-[#003366] focus:ring-1 focus:ring-[#003366]"
                    value={formData.department}
                    onChange={e => setFormData({ ...formData, department: e.target.value })}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">Place *</label>
                  <input
                    type="text"
                    required
                    className="w-full p-2 border rounded focus:border-[#003366] focus:ring-1 focus:ring-[#003366]"
                    value={formData.place}
                    onChange={e => setFormData({ ...formData, place: e.target.value })}
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium mb-1">Date *</label>
                  <input
                    type="date"
                    required
                    className="w-full p-2 border rounded focus:border-[#003366] focus:ring-1 focus:ring-[#003366]"
                    value={formData.date}
                    onChange={e => setFormData({ ...formData, date: e.target.value })}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">Time *</label>
                  <input
                    type="time"
                    required
                    className="w-full p-2 border rounded focus:border-[#003366] focus:ring-1 focus:ring-[#003366]"
                    value={formData.time}
                    onChange={e => setFormData({ ...formData, time: e.target.value })}
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Description/Causes *</label>
                <textarea
                  required
                  className="w-full p-2 border rounded focus:border-[#003366] focus:ring-1 focus:ring-[#003366]"
                  rows={4}
                  value={formData.description}
                  onChange={e => setFormData({ ...formData, description: e.target.value })}
                  placeholder="Describe the hazard or safety concern in detail"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Immediate Action Taken</label>
                <textarea
                  className="w-full p-2 border rounded focus:border-[#003366] focus:ring-1 focus:ring-[#003366]"
                  rows={3}
                  value={formData.immediateAction}
                  onChange={e => setFormData({ ...formData, immediateAction: e.target.value })}
                  placeholder="Describe any immediate actions taken to address the hazard"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Suggestion for Improvement</label>
                <textarea
                  className="w-full p-2 border rounded focus:border-[#003366] focus:ring-1 focus:ring-[#003366]"
                  rows={3}
                  value={formData.suggestion}
                  onChange={e => setFormData({ ...formData, suggestion: e.target.value })}
                  placeholder="Provide suggestions for preventing similar hazards in the future"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Observed by (Optional)</label>
                <input
                  type="text"
                  className="w-full p-2 border rounded focus:border-[#003366] focus:ring-1 focus:ring-[#003366]"
                  value={formData.observedBy}
                  onChange={e => setFormData({ ...formData, observedBy: e.target.value })}
                  placeholder="Print Your Name (Optional)"
                />
              </div>

              <button
                type="submit"
                className="w-full bg-[#003366] text-white py-3 px-4 rounded hover:bg-[#004080] transition-colors text-sm md:text-base"
              >
                Submit Observation
              </button>
            </form>
          </div>
        </div>
      </main>

      {/* Footer - Full width always */}
      <footer className="bg-[#003366] w-full py-4 mt-6">
        <div className="container mx-auto px-4">
          <p className="text-white text-center text-xs md:text-sm">
            Copyright © {new Date().getFullYear()} Mazenco Marine Services
          </p>
        </div>
      </footer>
    </div>
  );
};

export default HazardObservationForm;